export const GET_CUSTOMERS = 'app/get_customers'
export const GET_CUSTOMER_BY_ID = 'app/get_customer_by_id'
export const DELETE_CUSTOMER_BY_ID = 'app/delete_customer'
export const CREATE_CUSTOMER = 'app/create_customer'
export const UPDATE_CUSTOMER = 'app/update_customer'
